import { useState, useEffect } from "react";
import { useApi } from "../../hooks/use-api";
import {
  API_GRAMMAR_EXERCISE,
  API_GRAMMAR_SUBMIT,
} from "../../utils/api-routes";
import { useSingleton } from "../../hooks/use-singleton";

export const useHandler = () => {
  const { post } = useApi();
  const [grammarData, setGrammarData] = useState(null);
  const { mail } = useSingleton();
  const [showEvaluation, setShowEvaluation] = useState(false);
  const [loading, setLoading] = useState(false);

  const questionTypeMap = {
    MCQ: "mcq",
    "Fill in the blanks": "fill_blank",
    Both: "mixed",
  };
  const getGrammarExercise = async ({
    topic,
    difficulty,
    questionType,
    numQuestions,
    userMail,
  }) => {
    const payload = {
      topic,
      level: difficulty.toLowerCase(),
      question_type: questionTypeMap[questionType],
      num_questions: Number(numQuestions),
      user_mail: mail,
    };
    try {
      setLoading(true);

      const response = await post(API_GRAMMAR_EXERCISE, payload);

      setGrammarData(response.data);

      return response.data;
    } catch (error) {
      console.error("Error fetching grammar data:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  const submitGrammarExercise = async ({ exerciseId, userMail, answers }) => {
    const payload = {
      exercise_id: exerciseId,
      user_mail: mail,
      answers,
    };

    try {
      setLoading(true);

      const response = await post(API_GRAMMAR_SUBMIT, payload);

      return response.data;
    } catch (error) {
      console.error("Error submitting grammar answers:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return {
    grammarData,
    getGrammarExercise,
    showEvaluation,
    setShowEvaluation,
    submitGrammarExercise,
    loading,
    setLoading,
  };
};
